export enum ELcFieldType {
  BOOKING = 'booking',
  REPORT = 'report',
}
